import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from './SDA/AuthService';
import { getSessionStorage } from './utils/helpers';

const ProtectedRoute = ({ component: Component, children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const user = await AuthService.getUserToken();
      if (user && AuthService.isAuthenticated()) {
        setIsAuthenticated(true);
      } else {
        if (location.pathname === '/unauthorized' || location.pathname === '/session-timeout') {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(false);
        }
      }

      setIsLoading(false);
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/session-timeout" state={{ from: location.pathname }} />;
};

export default ProtectedRoute;
